(function () {
  if (window.__tempoLimitadoGalleryBooted) {
    return;
  }
  window.__tempoLimitadoGalleryBooted = true;

  var DEFAULT_API_URL = "https://apipalimpsesto.ocarlosantos.space/api/public/tempo-limitado";
  var ROOT_SELECTOR = "[data-tempo-limitado-root]";
  var GRID_SELECTOR = "[data-tempo-limitado-grid]";
  var STATUS_SELECTOR = "[data-tempo-limitado-status]";

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function fileLabel(name) {
    return String(name || "")
      .replace(/\.[^/.]+$/, "")
      .replace(/[-_]+/g, " ")
      .trim();
  }

  function setStatus(root, message, state) {
    var status = root.querySelector(STATUS_SELECTOR);
    if (!status) {
      status = document.createElement("p");
      status.className = "tempo-limitado__status";
      status.setAttribute("data-tempo-limitado-status", "");
      var grid = root.querySelector(GRID_SELECTOR);
      if (grid && grid.parentNode) {
        grid.parentNode.insertBefore(status, grid.nextSibling);
      } else {
        root.appendChild(status);
      }
    }
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = "";
      status.removeAttribute("data-state");
      return;
    }
    status.hidden = false;
    status.textContent = message;
    if (state) {
      status.setAttribute("data-state", state);
    } else {
      status.removeAttribute("data-state");
    }
  }

  function renderItems(root, items) {
    var grid = root.querySelector(GRID_SELECTOR);
    if (!grid) return;

    grid.innerHTML = items
      .map(function (item) {
        var imageUrl = escapeHtml(item.public_url || item.image_url || "");
        var name = String(item.name || "").trim();
        var altText = escapeHtml(fileLabel(name) || "Tempo Limitado");

        return [
          '<div class="tempo-limitado__card">',
          '<div class="tempo-limitado__media">',
          '<img ',
          'src="' + imageUrl + '"',
          'alt="' + altText + '"',
          'class="tempo-limitado__image"',
          'loading="lazy"',
          'width="1200"',
          'height="1600"',
          ">",
          "</div>",
          "</div>",
        ].join("");
      })
      .join("");
  }

  function init(root) {
    if (root.getAttribute("data-tempo-limitado-initialized") === "true") {
      return;
    }

    root.setAttribute("data-tempo-limitado-initialized", "true");

    var apiUrl = root.getAttribute("data-api-url") || DEFAULT_API_URL;
    if (!apiUrl) return;

    setStatus(root, "Atualizando galeria...", "loading");

    fetch(apiUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("api_error");
        }
        return response.json();
      })
      .then(function (payload) {
        var items = Array.isArray(payload && payload.items) ? payload.items : [];
        if (!items.length) {
          renderItems(root, []);
          setStatus(root, "Nenhuma imagem disponível no momento.", "empty");
          return;
        }
        renderItems(root, items);
        setStatus(root, "", "");
      })
      .catch(function () {
        renderItems(root, []);
        setStatus(root, "Não foi possível carregar a galeria agora.", "error");
      });
  }

  function boot() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) {
      var grids = document.querySelectorAll(GRID_SELECTOR);
      for (var gridIndex = 0; gridIndex < grids.length; gridIndex += 1) {
        var grid = grids[gridIndex];
        var fallbackRoot =
          grid.closest(".page-width") ||
          grid.parentElement ||
          grid;

        if (!fallbackRoot.hasAttribute("data-api-url")) {
          fallbackRoot.setAttribute("data-api-url", DEFAULT_API_URL);
        }

        init(fallbackRoot);
      }
      return;
    }

    for (var index = 0; index < roots.length; index += 1) {
      init(roots[index]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
